/* No analytics, fake listings or third-party dependencies. */
(() => {
  const key = 'potato-marketplace-saved-v1';
  let saved = new Set();
  try { const stored = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(stored)) saved = new Set(stored.filter(x => typeof x === 'string')); } catch (_) {}
  const isSavedView = () => document.querySelector('[data-saved-filter]')?.getAttribute('aria-pressed') === 'true';
  function paintSaved() {
    document.querySelectorAll('[data-save]').forEach(b => b.setAttribute('aria-pressed', String(saved.has(b.dataset.save))));
    let visible = 0;
    document.querySelectorAll('[data-card]').forEach(card => { card.hidden = isSavedView() && !saved.has(card.dataset.handle); if (!card.hidden) visible++; });
    const empty = document.querySelector('[data-saved-empty]'); if (empty) empty.hidden = !isSavedView() || visible > 0;
  }
  function init() {
    paintSaved();
    const select = document.querySelector('[data-variant-select]');
    if (select) syncVariant(select);
  }
  function syncVariant(select) {
    const v = select.selectedOptions[0]; if (!v) return;
    const price = document.querySelector('[data-variant-price]'); if (price) price.textContent = v.dataset.price;
    const compare = document.querySelector('[data-variant-compare]'); if (compare) { compare.textContent = v.dataset.compare; compare.hidden = !v.dataset.compare; }
    const add = document.querySelector('[data-add]'); if (add) { add.disabled = v.dataset.available !== 'true'; add.textContent = add.disabled ? 'Sold out' : 'Add to cart'; }
  }
  document.addEventListener('click', e => {
    const open = e.target.closest('[data-open]');
    if (open) { const d = document.querySelector(`[data-dialog="${open.dataset.open}"]`); if (d && !d.open) { d.showModal(); d.querySelector('input')?.focus(); } }
    if (e.target.closest('[data-close]')) e.target.closest('dialog')?.close();
    const save = e.target.closest('[data-save]');
    if (save) { const handle = save.dataset.save; saved.has(handle) ? saved.delete(handle) : saved.add(handle); try { localStorage.setItem(key, JSON.stringify([...saved])); } catch (_) {} paintSaved(); }
    const filter = e.target.closest('[data-saved-filter]');
    if (filter) { filter.setAttribute('aria-pressed', String(!isSavedView())); paintSaved(); document.querySelector('#pm-content')?.scrollIntoView({block:'start'}); }
  });
  document.addEventListener('change', e => { if (e.target.matches('[data-variant-select]')) syncVariant(e.target); });
  document.addEventListener('shopify:section:load', init);
  init();
})();
